import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IProductTypeOverview, IBakery } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  templateUrl: './check-delivery-modal.component.html',
  styleUrls: ['./check-delivery-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckDeliveryModalComponent implements OnInit {
  @Input() productType: IProductTypeOverview;
  @Input() bakery: IBakery;
  @Input() bakeryOverviewUrl: string;

  public bakeryCurrency: string;

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.bakeryCurrency = this.productType.bakery.country.currencySymbol;
  }

  public orderCake() {
    this.modal.close({ productTypeId: this.productType.id });
  }
}
